import { ActionType } from "../../../base/types";
import { AsideMenuActionGroup } from "./AsideMenuActionGroup";
import { AsideMenuActionLink } from "./AsideMenuActionLink";
import { AsideMenuActionPageLink } from "./AsideMenuActionPageLink";
import { AsideMenuPortalLink } from "./AsideMenuPortalLink";
import { AsideMenuTOULink } from "./AsideMenuTOULink";
import { AsideMenuUMSLink } from "./AsideMenuUMSLink";
import { IPageAction } from "../../../base/models";
import { AsideMenuLink } from "./AsideMenuLink";

export const AsideMenuActionItem = ({ action, className, hasBullet = false }: {
    action: IPageAction,
    className?: string,
    hasBullet?: boolean
}) => {
    switch (action.type) {
        case ActionType.Action:
            return <AsideMenuActionPageLink
                action={action}
                hasBullet={hasBullet}
                className={className} />
        case ActionType.ActionLink:
            return <AsideMenuActionLink
                action={action}
                hasBullet={hasBullet}
                className={className} />
        case ActionType.ActionGroup:
            return <AsideMenuActionGroup
                action={action}
                className={className} />
        case ActionType.TOULink:
            return <AsideMenuTOULink
                action={action}
                hasBullet={hasBullet}
                className={className} />
        case ActionType.UMSLink:
            return <AsideMenuUMSLink
                action={action}
                hasBullet={hasBullet}
                className={className} />
        case ActionType.PortalLink:
            return <AsideMenuPortalLink
                action={action}
                hasBullet={hasBullet}
                className={className} />
        case ActionType.HyperLink:
            return <AsideMenuLink
                action={action}
                hasBullet={hasBullet}
                className={className} />
    }
}